module.exports = __webpack_public_path__ + "static/media/landing_background.0f1c2685.jpg";